import { render } from "./NavigationWrap.vue?vue&type=template&id=0461d5e3"
import script from "./NavigationWrap.vue?vue&type=script&lang=js"
export * from "./NavigationWrap.vue?vue&type=script&lang=js"

import "./NavigationWrap.vue?vue&type=style&index=0&id=0461d5e3&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__